export const FILTER_TYPES = ['all', 'my', 'open'] as const
export type FilterType = typeof FILTER_TYPES[number]
export const DEFAULT_FILTER: FilterType = 'all'

// Helper function to check if a value is a valid FilterType
export function isValidFilterType(value: string): value is FilterType {
  return FILTER_TYPES.includes(value as FilterType)
}
